export default __webpack_public_path__ + "static/media/arrowLeftFill.a152b07f.svg";